var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"risk-level-badge",style:({ backgroundColor: _vm.color, color: _vm.textColor }),attrs:{"variant":_vm.variant}},[_vm._v(" "+_vm._s(_vm.levelText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }